import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@ff-os/shared-react/components/buttons/button/Button';
import { Icon } from '@ff-os/shared-react/components/icons/Icon';
import { WindowButton } from '@ff-os/shared-react/components/window/partials/WindowButton';
import { WindowFooter } from '@ff-os/shared-react/components/window/partials/WindowFooter';
import { WindowHeader } from '@ff-os/shared-react/components/window/partials/WindowHeader';
import { useCloseWindow } from '@ff-os/shared-react/context/window/useWindowContext';
import { WindowContext } from '@ff-os/shared-react/context/window/WindowContext';
import { findReplaceTranslationKey } from '@ff-scene-plugins/gift-shared/findReplaceTranslationKey';
import { TextVariableInput } from '@gift-variable-plugins/text-shared/TextVariableInput';
import { TextInputControlProps } from '../TextInputControl';
import { TextInputControlWindowBody } from './TextInputControlWindowBody';
import styles from './TextInputControlWindow.module.scss';

export const TextInputControlWindow = ({
    name, variableIds, input
}: TextInputControlProps) => {

    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);

    const icon = input.content.length > 0
        ? <div className={styles.textPreview} style={textPreviewStylesOf(input)}>{input.content}</div>
        : <Icon type='text-bar' />;

    const title = input.content.length > 0
        ? t(findReplaceTranslationKey(name, 'variables_replace.text'))
        : t(name);

    return (
        <>
            <WindowButton chevron icon={icon} onClick={() => setIsOpen(true)}>
                {title}
            </WindowButton>

            <WindowContext isOpen={isOpen} close={() => setIsOpen(false)}>
                <WindowContext.Header>
                    <WindowHeader previous={useCloseWindow(() => setIsOpen(false))}>
                        {title}
                    </WindowHeader>
                </WindowContext.Header>
                <WindowContext.Body>
                    <TextInputControlWindowBody variableIds={variableIds} />
                </WindowContext.Body>
                <WindowContext.Footer>
                    <WindowFooter justify='end'>
                        <Button onClick={useCloseWindow(() => setIsOpen(false))}>
                            {t('commons.save')}
                        </Button>
                    </WindowFooter>
                </WindowContext.Footer>
            </WindowContext>
        </>
    );
};

const textPreviewStylesOf = (input: TextVariableInput) => ({
    fontFamily: input.fontFamily,
    fontWeight: input.fontWeight,
    fontStyle: input.fontStyle
});